module.exports = __webpack_public_path__ + "img/Activeren5FA7C4.fe2c7d71.png";